import request from '@/utils/request'

const lopper = {
  name: 'lopper',
  state: {
    isLopperDetailLoading: false,
    lopperDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_LOPPER_DETAIL_LOADING: (state, data) => {
      state.isLopperDetailLoading = data
    },
    SET_MODULES_LOPPER_DETAIL_DATA: (state, data) => {
      state.lopperDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryLopperDetailData({ commit }, id) {
      commit('SET_IS_MODULES_LOPPER_DETAIL_LOADING', true)
      commit('SET_MODULES_LOPPER_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/lopper/lopperDetails',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_LOPPER_DETAIL_LOADING', false)
          commit('SET_MODULES_LOPPER_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_LOPPER_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetLopperDetailData({ commit }) {
      commit('SET_MODULES_LOPPER_DETAIL_DATA', {
        associatedId: '',
        content: '',
        name: '',
        orderNum: 0,
        looperType: 4
      })
    },
    //  设置账号新增页面数据
    setLopperDetailData({ commit }, data) {
      commit('SET_MODULES_LOPPER_DETAIL_DATA', data)
    }
  }
}

export default lopper
